module.exports = __webpack_public_path__ + "img/exhibition-img4.98c89058.png";